<template lang='pug'>
	v-text-field(
		v-bind='fieldProps'
		v-model='_value'
	)
		slot( name='append-outer' slot='append-outer' )
		slot( name='prepend' slot='prepend' )
		slot( name='prepend-inner' slot='prepend-inner' )
		template( slot='append' )
			v-btn(
				class='pa-0'
				icon
				flat
				large
				style='margin:-12px 6px 0px;' 
				v-bind='buttonProps'
				v-model='displayPassword' 
				@click='displayPassword ^= 1' 
			)
				v-icon visibility
</template>

<script>
	export default {
		computed: {
			buttonColor() {
				return this.displayPassword ? 'primary' : ''
			},
			buttonProps() {
				return {
					color: this.buttonColor,
				}
			},
			fieldProps() {
				return {
					...this.$attrs,
					type: this.fieldType,
				}
			},
			fieldType() {
				return this.displayPassword ? 'text' : 'password'
			},
			_value: {
				get() {
					return this.value
				},
				set(value) {
					this.$emit('input', value)
				}
			},
		},
		data() {
			return {
				displayPassword: 0,
			}
		},
		props: {
			value: {
				type: String,
				default: '',
			}
		}
	}
</script>
